import React from 'react';
interface TitleSlideProps {
  content: {
    subtitle: string;
    presenter: string;
    date: string;
  };
}
export function TitleSlide({
  content
}: TitleSlideProps) {
  return <div className="bg-gradient-to-br from-[#1C1C1C] to-[#017C6D] rounded-2xl p-16 text-center min-h-[600px] flex flex-col items-center justify-center" data-id="element-220">
      <div className="mb-8" data-id="element-221">
        <div className="text-[#0FB07D] text-6xl font-bold mb-2" data-id="element-222">VIRIDIA</div>
        <div className="text-[#F5F5F5] text-sm tracking-widest" data-id="element-223">ANALYTICS</div>
      </div>

      <h1 className="text-5xl font-bold text-white mb-6 leading-tight max-w-4xl" data-id="element-224">
        Stop Losing Leads While You're in the Field
      </h1>

      <p className="text-2xl text-[#F5F5F5] mb-12 max-w-3xl" data-id="element-225">
        {content.subtitle}
      </p>

      <div className="flex items-center gap-8 text-[#F5F5F5]" data-id="element-226">
        <div className="text-lg" data-id="element-227">{content.presenter}</div>
        <div className="w-1 h-1 bg-[#F5F5F5] rounded-full" data-id="element-228" />
        <div className="text-lg" data-id="element-229">{content.date}</div>
      </div>
    </div>;
}
export default TitleSlide;